const React = require('react')
const PropTypes = require('prop-types')
const MediumImage = require('./medium_image')
const Headline = require('../components/headline')
const Name = require('../components/name')
const Portfolio = require('../components/portfolio')
const Spotlight = require('../components/spotlight')
const Video = require('../components/video')
const Bio = require('../components/bio')
const Meta = require('../components/meta')
const Testimonials = require('../components/testimonials')
const ContactMeSection = require('../components/contact_me_section')
const SocialLinks = require('../components/social_links')
const BackgroundGradientStyle = require('../components/background_gradient_style')
const ProTrialMinibar = require('../components/pro_trial_minibar')
const hasFeature = require('module/user/helpers/has_feature')

class MediumProfileView extends React.Component {
    componentDidMount() {
        this.neuterTabIndex()
        this.addElementQuery()
    }

    addElementQuery() {
        // load requirements
        const $ = require('lib/jquery')
        require('jquery-elementquery')

        // stash reference to this.$el
        this.$el = $(this.el)

        // apply element query
        this.$el.elementQuery([
            'max-width: 640',
        ])
    }

    neuterTabIndex() {
        const { nested } = this.props

        if (nested) {
            const $ = require('lib/jquery')
            this.$el = $(this.el)
            const els_to_detab = [
                'a',
                'iframe',
                'button',
            ]
            this.$el.find(els_to_detab.join(', ')).attr('tabindex', '-1')
        }
    }

    render() {
        const {
            user,
            className,
            color,
            luminance,
            nested,
        } = this.props

        const has_portfolio = hasFeature(user, 'portfolio')

        return (
            <div
                className={className}
                ref={(el) => { this.el = el }}
                >
                <BackgroundGradientStyle
                    color={color}
                    luminance={luminance}
                    nested={nested}
                    />
                <div className="profile-content">
                    <div className="head">
                        <MediumImage user={user} />
                        <div className="name-headline">
                            <Name user={user} />
                            <Headline user={user} />
                        </div>
                    </div>
                    <div className="body">
                        <div className="body-content">
                            <Spotlight user={user} color={color} luminance={luminance} />
                            {has_portfolio && <Portfolio user={user} />}
                            {! has_portfolio && <Video user={user} nested={nested} />}
                            <Bio user={user} />
                            <Meta user={user} />
                            {has_portfolio && <Video user={user} nested={nested} />}
                            <Testimonials user={user} color={color} luminance={luminance} />
                            <ContactMeSection user={user} color={color} luminance={luminance} />
                            <SocialLinks user={user} />
                        </div>
                        {! nested && <ProTrialMinibar user={user} />}
                    </div>
                </div>
            </div>
        )
    }
}

MediumProfileView.propTypes = {
    user: PropTypes.object.isRequired,
    className: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    luminance: PropTypes.string.isRequired,
    nested: PropTypes.bool.isRequired,
}

module.exports = MediumProfileView
